module.exports = __webpack_public_path__ + "media/images/admin/bulk_mail-af908bf494d1c3166498f8c37dfbe3cf.png";